import React from "react";
import { ParallaxBanner } from "react-scroll-parallax";
import "./ParallaxSection.css";


function ParallaxSection({ backgroundImage, imageOnLeft, imageSrc, textContent, height = "100vh", hasOverlay = false }) {
  return (
    <ParallaxBanner
    layers={[{ image: backgroundImage, speed: -40 }]}
    style={{ height: 'auto', minHeight: height, position: "relative" }}
    >
      {hasOverlay && <div className="parallax-overlay" />}

      <div className="parallax-section">
        <div className="parallax-content">
          {imageOnLeft && imageSrc && (
            <div className="parallax-image">
              <img src={imageSrc} alt="Parallax visual" />
            </div>
          )}

          <div className="parallax-text">{textContent}</div>

          {!imageOnLeft && imageSrc && (
            <div className="parallax-image">
              <img src={imageSrc} alt="Parallax visual" />
            </div>
          )}
        </div>
      </div>
    </ParallaxBanner>
  );
}


export default ParallaxSection;